module.exports = __webpack_public_path__ + "static/media/S (154).422c5e7b.jpg";